import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Styling/Invoice.css";
import { getInvoiceData } from '../Api/ViewPostedInvoice';
import { Base_URL } from "../url";
import { useReactToPrint } from "react-to-print";
import InvoiceHeader from "./InvoiceHeader";
import InvoiceBody from "./invoiceBody";
import InvoiceFooter from "./InvoiceFooter";
import axios from "axios";
import VendorInvoiceHeader from "./VendorInvoiceHeader";
import VendorInvoiceBody from "./VendorInvoiceBody";
const { ToWords } = require('to-words');




const VendorInvoicePrintTest = () => {
  const componentRef = useRef();
  const toWords = new ToWords();
  const location = useLocation();
  const[prints,setPrints]=useState(1);




  const handlePrint = useReactToPrint({
    contentRef: componentRef, // ✅ new API for v3+
    documentTitle: "Invoice",
  });

  const invoiceId = location.pathname.split("/")[2];
  const [invoiceData, setInvoiceData] = useState({});
  const [count, setCount] = useState("");
  useEffect(() => {
    const fetchInvoiceData = async () => {
      const res = await axios.get(`${Base_URL}/VendorInvoice/id?id=${invoiceId}`);
      console.log(res, 'res dngjf jhjkdt hjkt');
      setInvoiceData(res.data)
      setCount(res?.items?.length)
      setPrints(res?.print?.numberOfPrints)
    }
    fetchInvoiceData()
  }, [])
    console.log(invoiceData,'InvoiceData')
  // Function to handle the download button click
  const handleDownload = async () => {
    try {
      // const response = await fetch("https://localhost:7039/api/InvoicePdf/DownloadSampleInvoice", {
      //   method: "GET",
      //   headers: {
      //     "Content-Type": "application/pdf",
      //   },
      // });
      const response = await fetch(`${Base_URL}/InvoicePdf/DownloadSampleInvoice?invoiceid=${invoiceId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf",
        },
      });

      console.log(response, 'response in file download')

      return
 } catch (error) {
      console.error("Error downloading invoice:", error);
      alert("Failed to download invoice. Please try again.");
    }
  };
  console.log(invoiceData, 'invoiceData')

  return (
    <>
      {/* ===== Download Button Row ===== */}
      <div className="container-fluid no-print">
  <div className="row mt-5">
    <div className="col-8 mt-5"></div>

    <div className="col-4 text-end mt-5 d-flex justify-content-end align-items-center">
      <label className="me-2 fw-semibold prints-label">
  Enter Number of Prints
</label>


      <input
        
        value={prints}
        onChange={(e) => setPrints(e.target.value)}
        className="prints-input me-2"
      />

      <button className="btn btn-primary" onClick={handlePrint}>
        Download Invoice
      </button>
    </div>
  </div>
</div>


   
    <div ref={componentRef}>
  {/* original invoice copy */}
  <div className="invoice-print">
    <VendorInvoiceHeader invoiceData={invoiceData} />
    <VendorInvoiceBody invoiceData={invoiceData} />
    <InvoiceFooter />
  </div>

  {/* hidden duplicates */}
  {Array.from({ length: prints - 1 }).map((_, index) => (
   <div className="invoice-print invoice-duplicate">
   <InvoiceHeader invoiceData={invoiceData} />
    <InvoiceBody invoiceData={invoiceData} />
    <InvoiceFooter />
  </div>
  ))}

</div>

    </>

  );
};

export default VendorInvoicePrintTest;